export const ReduceFunction = (arr, key) => {
    return arr
      ?.map((v) => Number(v?.[key] || 0)) 
      ?.reduce((a, b) => a + b, 0)        
      ?.toFixed(2);                       
  }
  